export const noAccount = '-1'
export const freeAccount = '0'
export const subscribeAccount = '1'
export const oldSubscribeAccount = '2'
